import axios from 'axios'

const API = axios

API.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
API.defaults.headers.common['Content-Type'] = 'application/json'

// Add a request interceptor to send the currently selected subsidiary on
// every call, so it always reflects the latest "Cambiar Sucursal" choice
// without needing a page reload.
API.interceptors.request.use(function(config) {
    try {
        const sucursal = JSON.parse(localStorage.getItem('sucursal'))
        if (sucursal && sucursal.id) {
            config.headers['X-Subsidiary-Id'] = sucursal.id
        }
    } catch (e) {}
    return config
})

// Add a response interceptor
API.interceptors.response.use(
    function(response) {
        return response
    },
    function(error) {
        error.message = 'Ha ocurrido un error inesperado'

        if (error.response && error.response.data && error.response.data.message) {
            console.warn(error.response.data.message)
            error.message = Array.isArray(error.response.data.message)
                ? error.response.data.message[0]
                : error.response.data.message
        }
        return Promise.reject(error)
    }
)

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// axios.defaults.baseURL = "http://localhost:8000/api/";

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    API.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

export default API
